<template>
  <v-snackbar
    :value="isVisible"
    :color="color"
    :timeout="timeout"
    :bottom="y"
    :right="x"
    @change="closeSnackbar"
  >
    <span>{{ text }}</span>
    <v-btn flat color="white" @click="closeSnackbar">Close</v-btn>
  </v-snackbar>
</template>
<script>
export default {
  props: {
    isVisible: Boolean,
    text: String,
    color: String,
    timeout: Number,
    y: String,
    x: String
  },
  methods: {
    closeSnackbar() {
      this.$emit("closeSnackbar");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/shared/Snackbar.vue